export const COOKIE_NAME = 'Consent';

export const ACCEPTED_VALUE = 'true';
